var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-container"},[_c('p',[_vm._v("Prix total : "),_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.totalPrice)+" €")])])])}
var staticRenderFns = []

export { render, staticRenderFns }